const styles = theme => ({
    wrapperRelevant: {
        maxWidth: '1300px',
        margin: '0 auto',
        minHeight: '400px',
    },
    bgRelevant: {
        backgroundColor: `${theme.palette.primary.main}`,
    },
    verticalTabs: {
        marginTop: '96px',
        // minHeight: '400px',
        width: '100%',
        position: 'relative',
        '& .MuiTabs-indicator': {
            display: 'none',
        }
    },
    verticalTabsFlexContainer: {
        flexDirection: 'column !important',
        alignItems: 'stretch !important',
    },
    tabTextWhite: {
        color: '#fff',
    },
    verticalTab: {
        minHeight: '48px',
        maxWidth: '100%',
        textAlign: 'left',
        alignItems: 'flex-start !important',
        justifyContent: 'center',
        textTransform: 'none',
        fontSize: '14px',
        fontWeight: 500,
        padding: '12px 0',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        position: 'relative',
        overflow: 'hidden',
        opacity: 1,
        '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            height: '100%',
            width: '4px',
            backgroundColor: '#055EC2',
            transform: 'scaleX(0)',
            transformOrigin: 'left',
            transition: 'transform 0.3s ease, width 0.3s ease',
        },
        '&:hover': {
            color: '#fff',
        },
        '&:hover::before': {
            transform: 'scaleX(1)',
            width: '100%',
        },
        '&[aria-selected="true"]::before': {
            transform: 'scaleX(1)',
            width: '3px',
        },
        '&[aria-selected="true"]:hover::before': {
            transform: 'scaleX(1)',
            width: '100%',
        },
        '& > span:first-child': {
            zIndex: 10,
            alignItems: 'flex-start !important',
        },
    },
    tabIndicator: {
        backgroundColor: '#055EC2',
        [theme.breakpoints.up('md')]: {
            width: '3px',
            right: 0,
            left: 'auto',
            display: 'none'
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            height: '100%',
            zIndex: 1,
            bottom: 0
        }
    },
    horizontalTabs: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        marginBottom: '16px',
        '& .MuiTabs-scroller': {
            overflow: 'auto !important',
        },
        '& div[class*="btnScroll"]': {
            display: 'none',
        }
    },
    horizontalTab: {
        minWidth: 'auto',
        padding: '12px 16px',
        textTransform: 'none',
        fontSize: '14px',
        fontWeight: 500,
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        '& > span:first-child': {
            zIndex: 10,
        },
        '&[aria-selected="true"]': {
            color: '#fff',
        }
    }
});

export default styles;